import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './authenticationSlice';
import regionSlice from './regionSlice';
import projectsSlice from './projectsSlice';
import productSlice from './productSlice';
import financeSlice from './financeSlice';
import testuserSlice from './testuserSlice';
const rootReducer = combineReducers({
  auth: authSlice,
  region: regionSlice,
  projects: projectsSlice,
  products: productSlice,
  finance: financeSlice,
  testuser: testuserSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
